{
  "name": "53-Tertial (center D)",
  "description": "53-tone 3-Limit Rational Intonation scale, consisting of 53 notes per octave derived by tuning a chain of 53 3/2 perfect fifths: 26 are harmonics and 26 are subharmonics of D. This gives a symmetric, enharmonically respelled notation combining two HEJI symbols, tilde and arrow, to indicate alteration by a Syntonic Comma plus a Schisma, which is equal to a Pythagorean Comma. Jing Fang (78–37 BCE), a Chinese music theorist, observed that a sequence of 53 just fifths is very nearly equal to 31 octaves. Compare this tuning to the following tuning based on 5-Limit (with 2 enharmonic proximities added) and to the 53edo temperament.",
  "scale": [
    "531441/524288",
    "282429536481/274877906944",
    "134217728/129140163",
    "256/243",
    "2187/2048",
    "1162261467/1073741824",
    "34359738368/31381059609",
    "65536/59049",
    "9/8",
    "4782969/4194304",
    "2541865828329/2199023255552",
    "16777216/14348907",
    "32/27",
    "19683/16384",
    "10460353203/8589934592",
    "4294967296/3486784401",
    "8192/6561",
    "81/64",
    "43046721/33554432",
    "22876792454961/17592186044416",
    "2097152/1594323",
    "4/3",
    "177147/131072",
    "94143178827/68719476736",
    "536870912/387420489",
    "1024/729",
    "729/512",
    "387420489/268435456",
    "137438953472/94143178827",
    "262144/177147",
    "3/2",
    "1594323/1048576",
    "847288609443/549755813888",
    "67108864/43046721",
    "128/81",
    "6561/4096",
    "3486784401/2147483648",
    "17179869184/10460353203",
    "32768/19683",
    "27/16",
    "14348907/8388608",
    "7625597484987/4398046511104",
    "8388608/4782969",
    "16/9",
    "59049/32768",
    "31381059609/17179869184",
    "2147483648/1162261467",
    "4096/2187",
    "243/128",
    "129140163/67108864",
    "549755813888/282429536481",
    "1048576/531441",
    "2/1"
  ],
  "key_colors_mode": "manual",
  "short_description": "53-JI-3L",
  "built_in_group": "Rational Intonation (JI)",
  "key_labels": "note_names",
  "fundamental_color": "#ffdbe8",
  "note_names": [
    "C",
    "C",
    "C",
    "C",
    "C",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "E",
    "E",
    "E",
    "E",
    "E",
    "E",
    "E",
    "F",
    "F",
    "F",
    "F",
    "F",
    "F",
    "G",
    "G",
    "G",
    "G",
    "G",
    "G",
    "G",
    "G",
    "G",
    "A",
    "A",
    "A",
    "A",
    "A",
    "A",
    "A",
    "A",
    "A",
    "B",
    "B",
    "B",
    "B",
    "B",
    "B",
    "C",
    "C"
  ],
  "note_colors": [
    "#ffb5b5",
    "#e2caca",
    "#dfffd6",
    "#ffe5e5",
    "#d0d0d7",
    "#dee2da",
    "#e6d7fe",
    "#fef5be",
    "#fffae5",
    "#ffffff",
    "#e2caca",
    "#dfffd6",
    "#ffe5e5",
    "#d0d0d7",
    "#dee2da",
    "#e6d7fe",
    "#fef5be",
    "#fffae5",
    "#ffffff",
    "#e2caca",
    "#dfffd6",
    "#fffae5",
    "#ffffff",
    "#e2caca",
    "#dfffd6",
    "#ffe5e5",
    "#d0d0d7",
    "#dee2da",
    "#e6d7fe",
    "#fef5be",
    "#fffae5",
    "#ffffff",
    "#e2caca",
    "#dfffd6",
    "#ffe5e5",
    "#d0d0d7",
    "#dee2da",
    "#e6d7fe",
    "#fef5be",
    "#fffae5",
    "#ffffff",
    "#e2caca",
    "#dfffd6",
    "#ffe5e5",
    "#d0d0d7",
    "#dee2da",
    "#e6d7fe",
    "#fef5be",
    "#fffae5",
    "#ffffff",
    "#e2caca",
    "#fef5be",
    "#fffae5"
  ],
  "equivSteps": 53,
  "fundamental": 440,
  "reference_degree": 40,
  "center_degree": 9,
  "rSteps": 9,
  "drSteps": 4,
  "hexSize": 42,
  "rotation": -16.102113751,
  "lumatone_anchor_note": 27,
  "lumatone_anchor_channel": 3,
  "exquis_anchor_note": 9
}
